/**
 * Splits a product description into collapsible sections wherever a
 * heading appears — either a real heading tag (h1-h6), or a paragraph
 * used as a de-facto heading (a <p> containing nothing but a single
 * <strong> run) — the pattern produced when heading-styled text is pasted
 * in from outside editors instead of using a real heading tag.
 */
(function () {
  function isHeadingLike(el) {
    if (/^H[1-6]$/.test(el.tagName)) {
      return el.textContent.trim() !== '';
    }

    if (el.tagName !== 'P') return false;

    // Ignore stray non-visual elements (e.g. <meta> tags left behind by
    // pasted-in content) when checking whether this paragraph is really
    // just a single bold run used as a de-facto heading.
    var meaningfulChildren = Array.prototype.filter.call(el.children, function (child) {
      return child.tagName !== 'META';
    });

    return (
      meaningfulChildren.length === 1 &&
      meaningfulChildren[0].tagName === 'STRONG' &&
      el.textContent.trim() === meaningfulChildren[0].textContent.trim() &&
      el.textContent.trim() !== ''
    );
  }

  function splitIntoSections(container) {
    var children = Array.prototype.slice.call(container.children);
    var firstHeadingIndex = children.findIndex(isHeadingLike);

    if (firstHeadingIndex === -1) return;

    var fragment = document.createDocumentFragment();

    for (var i = 0; i < firstHeadingIndex; i++) {
      fragment.appendChild(children[i]);
    }

    var currentBody = null;

    for (var j = firstHeadingIndex; j < children.length; j++) {
      var el = children[j];

      if (isHeadingLike(el)) {
        var details = document.createElement('details');
        details.className = 'rte-section';

        var summary = document.createElement('summary');
        summary.className = 'rte-section__heading';
        summary.textContent = el.textContent.trim().replace(/:\s*$/, '');
        details.appendChild(summary);

        currentBody = document.createElement('div');
        currentBody.className = 'rte-section__content';
        details.appendChild(currentBody);

        fragment.appendChild(details);
      } else if (currentBody) {
        currentBody.appendChild(el);
      } else {
        fragment.appendChild(el);
      }
    }

    container.innerHTML = '';
    container.appendChild(fragment);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-single__description').forEach(splitIntoSections);
  });
})();
